// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yNljqwPJLEg2jM8GZJfa{transition:width .5s}.yNljqwPJLEg2jM8GZJfa .aEV08I9ZWsd55Gtfc4RV{gap:12px;padding-left:12px;padding-right:12px}.yNljqwPJLEg2jM8GZJfa .f9q9h2xTgZIZGG_Nv2pk{background-color:var(--action-contained-secondary-normal);width:38px;box-shadow:none}.yNljqwPJLEg2jM8GZJfa .f9q9h2xTgZIZGG_Nv2pk:hover{background:var(--action-contained-secondary-hovered);color:var(--content-brand-secondary);box-shadow:none;cursor:pointer}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `yNljqwPJLEg2jM8GZJfa`,
	"inputStyles": `aEV08I9ZWsd55Gtfc4RV`,
	"collapseInputStyles": `f9q9h2xTgZIZGG_Nv2pk`
};
export default ___CSS_LOADER_EXPORT___;
